import { render, staticRenderFns } from "./ReporteFallasMtto.vue?vue&type=template&id=28111a55&scoped=true"
import script from "./ReporteFallasMtto.vue?vue&type=script&lang=js"
export * from "./ReporteFallasMtto.vue?vue&type=script&lang=js"
import style0 from "./ReporteFallasMtto.vue?vue&type=style&index=0&id=28111a55&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28111a55",
  null
  
)

export default component.exports